module.exports = __webpack_public_path__ + "static/media/BANNERBGAME.52ecf2e7.png";